import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";


@Component({
	selector: 'app-cep-modal-info',
	templateUrl: './cep-modal-info.component.html',
	styleUrls: ['./cep-modal-info.component.styl'],
})
export class CepModalInfoComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<CepModalInfoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: string,
	) {
	}

	ngOnInit(): void {
	}

	close(): void {
		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/modal-cep/modal-info/cep-modal-info.component.ts